import React from 'react';

/* NoctuaMark — twin owl eyes, field-system rendition.
   Outlined rings with solid pupils (instrument-indicator style), matching
   the masthead and chassis-nav marks in
   brand/tx6/noctua_visual_identity_applied.html.
   Stroke width scales up at smaller sizes so the rings stay legible. */

interface NoctuaMarkProps {
  size?: number;
  className?: string;
  title?: string;
}

export default function NoctuaMark({ size = 24, className, title }: NoctuaMarkProps) {
  const ring = 'var(--color-mark)';
  /* Smaller marks need a thicker stroke (in viewBox units) to read. */
  const strokeWidth = size <= 28 ? 3 : 2.5;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {title ? <title>{title}</title> : null}
      <circle cx="21" cy="30" r="13" fill="none" stroke={ring} strokeWidth={strokeWidth} />
      <circle cx="21" cy="30" r="5" fill={ring} />
      <circle cx="39" cy="30" r="13" fill="none" stroke={ring} strokeWidth={strokeWidth} />
      <circle cx="39" cy="30" r="5" fill={ring} />
    </svg>
  );
}
